import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const MWRHistoryContentStyled = styled(Box).attrs({ px: { sm: '400' }, py: { sm: '450' } })`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[300]};
    font-size: ${theme.fontSizes[300]};
  `}
`;
